<template>
  <a-modal :title="null" width="800px" :visible="visible" @cancel="handelCancel" @ok="postConsentFormData"
    :destroyOnClose="true" :maskClosable="false" :confirmLoading="loading">
    <div class="box">
      <div ref="richContent" :style="{ height: '450px', overflow: 'auto' }" v-html="msgContent"></div>

      <hr>
      <!-- <p class="p3">受试者声明：我已经阅读了上述有关本研究的介绍，我的研究人员已向我充分解释和说 明了本研究的目的、操作过程以及参加本研究可能存在的风险和潜在的获益，并回答了我所有相关问题。自愿参加本研究。</p> -->

      <div class="tips">
        <!-- <span>我</span>
        <a-radio-group v-model="value" @change="onChange">
          <a-radio :value="1">
            同意
          </a-radio>或<a-radio :value="2">
            拒绝
          </a-radio>
        </a-radio-group>
        <span>除本研究以外的其他研究利用我的研究资料和生物标本。</span> -->
         <!-- 复选框 -->
        <a-checkbox :checked="agreeChecked" @change="handleAgreeChange">
        
          <span style="font-size: 13px; cursor: pointer;" @click.stop="showLegalModal = true">  我已阅读并同意《ERASE临床队列智能设计采集系统个人信息及隐私保护政策》</span>
        </a-checkbox>

    <!-- 法律条款模态框 -->
        <a-modal
          title="《ERASE临床队列智能设计采集系统个人信息及隐私保护政策》"
          :visible="showLegalModal"
          @ok="handleLegalConfirm"
          @cancel="handleLegalCancel"
          okText="已阅读并同意"
          cancelText="取消"
        >
          <div style=" height: 600px; overflow-y: auto;" v-html="securityContent">
           
          </div>
        </a-modal>
      </div>
      <br>
      <!-- <a-select style="width: 220px" @change="handleChange"> -->
      <div class="sign">
        <span>签字人员：</span>
        <a-select style="width: 220px" v-model="selected" @change="selectChange">
          <a-select-option value="1">
            受试者
          </a-select-option>
          <a-select-option value="2">
            法定代理人
          </a-select-option>
          <a-select-option value="3">
            见证人
          </a-select-option>
          <a-select-option value="4">
            医生
          </a-select-option>
        </a-select>
      </div>
      <div v-if="selected === '1'">
        <div class="sign">
          <span>日期：</span>
          <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' placeholder="请选择日期"
            v-model="params.patientDate" />
        </div>
      </div>
      <div v-if="selected === '2'">
        <div class="sign">
          <span>法定代理人姓名：</span>
          <input type="text" v-model="params.agentName" />
          <!-- <span>（如适用）</span> -->
        </div>
        <div class="sign">
          <span>日期：</span>
          <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' placeholder="请选择日期"
            v-model="params.agentDate" />
          <span>与患者关系：</span>
          <input type="text" v-model="params.agentRelationShip" />
        </div>
        <div class="sign">
          <span>需法定代理人签署的原因：</span>
          <input type="text" v-model="params.agentReason" />
        </div>
      </div>

      <div v-if="selected === '3'">
        <div class="sign">
          <span>见证人姓名：</span>
          <input type="text" v-model="params.witnessName" />
        </div>
        <div class="sign">
          <span>日期：</span>
          <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' placeholder="请选择日期"
            v-model="params.witnessDate" />
        </div>
        <div class="sign">
          <span>需见证人签署的原因：</span>
          <input type="text" v-model="params.witnessReason" />
        </div>
      </div>

      <div v-if="selected === '4'">
         <div class="sign">
          <span>医生联系方式：</span>
          <input type="text" v-model="params.doctorPhone" />
        </div>
        <div class="sign">
          <span>日期：</span>
          <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' placeholder="请选择日期"
            v-model="params.doctorDate" />
        </div>
      </div>

      <div class="signature">
        <div class="sign">电子签名：</div>
        <div class="sign-off">
          <canvas ref="signature" width="750" height="300"></canvas>
          <div class="btn">
            <a-button style="margin-right: 20px;" @click="clear">清除</a-button>
            <!-- <a-button type="primary" @click="upload">上传签名</a-button> -->
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { log } from '@/utils/util'
import { getAction, postAction, getFileAccessHttpUrl } from '@/api/manage'
export default {
  name: 'ConsentForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: 0,
      canvas: null,
      ctx: null,
      msgContent: '',
      securityContent:'',
      type: '0',
      selected: '1',
      // projectId: '',//1572115427468570626
      sign: '',//签名,图片路径
      params: {},
      loading: false,
      agreeChecked: false, // 控制复选框的勾选状态
      showLegalModal: false // 控制模态框的显示状态
    };
  },
  watch: {
    visible: function () {
      if (this.visible) {
        this.$nextTick(() => {
          this.canvas = this.$refs.signature;
          this.ctx = this.canvas.getContext('2d');
          this.canvas.addEventListener('touchstart', this.touchStart, { passive: false});
        });
        this.getDocumentTemplate();
        
      }
    }
  },
  mounted() {
    // this.projectId = this.$route.query.projectId;
  },
  methods: {
      // 复选框状态变化时的处理逻辑
      handleAgreeChange(e) {
      const checked = e.target.checked;
      if (checked) {
        // 如果用户勾选复选框，则显示条款模态框
        this.showLegalModal = true;
      } else {
        // 如果用户取消勾选，则直接重置状态
        this.agreeChecked = false;
      }
    },

    // 用户点击模态框的“确认”按钮时的处理逻辑
    handleLegalConfirm() {
      // 确认条款后，设置复选框为勾选状态，并关闭模态框
      this.agreeChecked = true;
      this.showLegalModal = false;
    },

    // 用户点击模态框的“取消”按钮时的处理逻辑
    handleLegalCancel() {
      // 取消操作时，重置复选框状态，并关闭模态框
      this.agreeChecked = false;
      this.showLegalModal = false;
    },

    selectChange(e) {
      this.selected = e
      this.loadCanvas()
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    },
    handleChange(value) {
      console.log(value)
    },
    handelCancel() {
      this.params={}
      this.$emit('toggleConsentForm', false)
      this.agreeChecked=false
    },
    loadImage(url) {
      const img = new Image();
      var imgurl = url//this.getImgView()
      // console.log("imgurl:"+imgurl)
      img.crossOrigin = 'Anonymous'; // 设置 crossOrigin 属性
      img.src = imgurl
      img.onload = () => {
        // console.log("img width:"+ img.width)
        this.ctx.drawImage(img, 0, 0, 350, this.$refs.signature.height);
      };
      
    },
    async getDocumentTemplate() {
      this.params.projectId = this.projectId
      this.params.patientId = this.patientId
      const res = await getAction('/project/template/queryByProjectId', { projectId: this.projectId })
      if (res.success && res.result != null) {
        const { msgContent, type,securityContent } = res.result;
        this.msgContent = msgContent;
        this.securityContent=securityContent;
        this.type = type;
        this.getDocumentData();
      }
    },
    async getDocumentData() {
      const res = await getAction('/patient/patientInformedConsentForm/queryByPatientId', { patientId: this.patientId })
      if (res.success && res.result != null) {
        this.params = res.result
        this.value = 1
        this.loadCanvas()
        this.agreeChecked=true       
        //模板中存在checkbox则进行数据回显
        if(this.params.msgContent){
          const dataList = JSON.parse(this.params.msgContent)
           for(let item of dataList){
            this.initCheckData(item)
          }          
        }
      
      }else{
        this.agreeChecked=false
        this.params = {}
        this.params.projectId = this.projectId
        this.params.patientId = this.patientId
      }
    },
    initCheckData(dataItem) {
    const dom = this.$refs.richContent;
    if (dom) {
      const id = dataItem.id;
      const checkbox = dom.querySelector(`input[type="checkbox"][id="${id}"]`);
      if (checkbox) checkbox.checked = dataItem.checked;
      console.log('已找到并设置checkbox');
    } else {
      console.log('未找到dom');
    }
  },
    loadCanvas() {
     this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      if (this.selected === '1' && this.params.patientSign) {
        this.loadImage(getFileAccessHttpUrl(this.params.patientSign))
      }
      if (this.selected === '2' && this.params.agentSign) {
        this.loadImage(getFileAccessHttpUrl(this.params.agentSign))
      }
      if (this.selected === '3' && this.params.witnessSign) {
        this.loadImage(getFileAccessHttpUrl(this.params.witnessSign))
      }
      if (this.selected === '4' && this.params.doctorSign) {
        this.loadImage(getFileAccessHttpUrl(this.params.doctorSign))
      }
    },
    isCanvasEmpty() {
      const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
      const data = imageData.data; // This gives us an Uint8ClampedArray
      
      for (let i = 0; i < data.length; i += 4) {
          // 每个像素由四个值表示: 红色、绿色、蓝色和alpha通道(不透明度)
          // 如果alpha值大于0，则意味着该像素不是完全透明的
          if (data[i + 3] > 0) {
              return false; // 找到非透明像素，画布包含内容
          }
      }
      return true; // 所有像素都是透明的，画布为空
    },
    upload(callback) {
      console.log("uploading...")
      if(!this.canvas){
        return this.$message.warning("请上传电子签名!")
      }
      if(this.isCanvasEmpty()){
        return this.$message.warning("请先上传电子签名!")
      }      
      this.canvas.toBlob(async blob => {
        if (blob) {
          this.loading = true
          try{
          const formData = new FormData();
          formData.append('file', blob, `${Date.now()}.png`);
          formData.append('biz', `${this.projectId}/patient/process/${new Date().getTime()}`)
          const res = await postAction('/sys/common/upload', formData);
          if (res.success) {
            // this.$message.success("上传成功!")
            this.sign = res.message;
            if (this.selected === '1'&&!this.params.patientSign) {
              this.params.patientSign = this.sign
            }
            if (this.selected === '2'&&!this.params.agentSign) {
              this.params.agentSign = this.sign
            }
            if (this.selected === '3'&&!this.params.witnessSign) {
              this.params.witnessSign = this.sign
            }
            if (this.selected === '4'&&!this.params.doctorSign) {
              this.params.doctorSign = this.sign
            }
            callback && callback()
          } else {
            this.loading = false
            this.$message.error("上传失败!")
            return false;
          }
          }catch(e){
            this.$message.error("发生异常，上传失败");
          }finally {
            this.loading = false;
          }
        }else{
          this.$message.warning("请先上传电子签名!")
          return false;
        }
      })
    },
    async postConsentFormData() {
      if( !this.agreeChecked) return this.$message.warning('请勾选”我已阅读并同意《ERASE临床队列智能设计采集系统个人信息及隐私保护政策》”！');
      // if (this.value === 0) return this.$message.warning('请选择同意操作，完成电子版知情同意书的签章！');
      // if (this.value === 2) return this.$message.warning('你已拒绝，请关闭此页面');
      this.upload(()=>{
        if (this.sign === '') {
          this.loading = false
          return this.$message.warning('请先上传电子签名');
        }
        this.params.projectId = this.projectId
        this.params.patientId = this.patientId
      // 1. 获取渲染后的DOM
      const dom = this.$refs.richContent;
      // 2. 查询所有checkbox
      const checkboxes = dom.querySelectorAll('input[type="checkbox"]');
      if(checkboxes){
        // 3. 解析选中状态和文本
        const result = Array.from(checkboxes).map(cb => ({
          checked: cb.checked,
          label: cb.nextSibling ? cb.nextSibling.textContent.trim() : '',
          id: cb.id
        }));
        // 4. 打印或提交到后端
        if(result.length>0){
          this.params.msgContent=JSON.stringify(result)     
        } 
      }
     
      postAction('/patient/patientInformedConsentForm/add', this.params).then(res => {
          if (res.success) {
            this.$message.success("操作成功!")
            this.$emit('toggleConsentForm', false)
            this.params={}
          }
        }).finally(() => {
          this.loading = false
        })
      })      
    },
    clear() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      if (this.selected === '1') {
          this.params.patientSign = null
      }
      if (this.selected === '2') {
          this.params.agentSign = null
      }
      if (this.selected === '3') {
          this.params.witnessSign = null
      }
      if (this.selected === '4') {
          this.params.doctorSign = null
      }
    },
    touchStart(ev) {
      ev.preventDefault();
      this.ctx.beginPath();
      const { clientX, clientY } = ev.touches[0];
      const { left, top } = this.canvas.getBoundingClientRect();
      const x = clientX - left;
      const y = clientY - top;
      this.ctx.moveTo(x, y);

      this.canvas.addEventListener("touchmove", this.touchMove, { passive: false});
      this.canvas.addEventListener("touchend", this.touchEnd);
    },
    touchMove(ev) {
      ev.preventDefault();
      const { left, top } = this.canvas.getBoundingClientRect();
      const { clientX, clientY } = ev.touches[0];
      const x = clientX - left;
      const y = clientY - top;
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
    },
    touchEnd() {
      this.ctx.closePath();
      this.canvas.removeEventListener('touchmove', this.touchMove)
      this.canvas.removeEventListener('touchend', this.touchEnd)
    },
  }
}
</script>

<style scoped lang="less">
.title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  line-height: 45px;
}

.p1,
.p2,
.p3 {
  margin: 0;
}

.p1 {
  margin-top: 20px;
}

.p2 {
  text-indent: 2em;
  line-height: 20px;
  margin-top: 15px;
}

.p3 {
  text-indent: 2em;
  line-height: 20px;
  margin-top: 15px;
}

.list {
  dt {
    text-indent: 2em;
    font-weight: bold;
  }

  dd {
    text-indent: 3em;
    margin-bottom: 0;
    line-height: 20px;
  }
}

.tips {
  margin-top: 15px;

  span:first-of-type {
    display: inline-block;
  }
}

/deep/ .ant-radio-wrapper {
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 0;

  span {
    padding: 0;
  }
}

.sign {
  margin-top: 20px;
  text-indent: 2em;
  display: flex;
  align-items: center;

  span {
    word-break: keep-all;
  }

  input {
    flex: 1;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgb(155, 155, 155);
    outline: none;

    &:active {
      border-color: rgb(155, 155, 155);
    }

    &:focus {
      border-color: rgb(155, 155, 155);
    }
  }
}

.signature {
  overflow: hidden;
  margin-top: 10px;

  .sign-off {
    // display: flex;
    // flex-direction: column;
    // align-items: flex-end;
    // row-gap: 20px;
    overflow: hidden;
    margin-top: 15px;
  }

  canvas {
    display: block;
    border: 1px dashed gray;
  }

  .btn {
    margin-top: 10px;
    text-align: right;
  }
}
</style>
